import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { RunIntersectionRule } from "../../../rule-engine-core/Flow/Steps/Rules/RunIntersectionRule";
// import { StyledButton } from "../../../CommonUI/Components/Button";
// import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
// import { BaseFlowRuleStep } from "../../../Common/Flow/Steps/Rules/BaseFlowRuleStep";
// import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
// import { StateManager } from "../../../Common/Common/StateManager";
// import { StepStrategySelectionButtonGroup } from "../Common/StepStrategySelectionButtonGroup";
// import { Layer } from "../../../CommonUI/Components/Layer";
// import { IntersectionRuleBuilder } from "../../../Rule/Intersection/IntersectionRuleBuilder";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StepEditUI = ({ step }: { step: RunIntersectionRule }) => {
    //    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <></>
        // <>
        //     <StyledButton sx={{color:UIStyleConstants.BLUE_COLOR}} variant="contained" onClick={() => setOpen(true)}>
        //         Edit {step.name || "Rule Step"}
        //     </StyledButton>
        //     {step.needSetOutcomeName && (
        //         <ObserveState
        //             listenTo={step}
        //             properties={[BaseFlowRuleStep.OUTCOME_NAME]}
        //             control={() => (
        //                 <PropertyEditorText
        //                     label="Outcome Name"
        //                     editObject={step}
        //                     propertyName={BaseFlowRuleStep.OUTCOME_NAME}
        //                     updateCallback={() => {
        //                         StateManager.propertyChanged(step, BaseFlowRuleStep.OUTCOME_NAME);
        //                     }}
        //                 />
        //             )}
        //         />
        //     )}
        //
        //     {step.canChangeOutputStrategy && (
        //         <ObserveState
        //             listenTo={step}
        //             properties={[BaseFlowRuleStep.OUTCOME_STRATEGY]}
        //             control={() => (
        //                 <StepStrategySelectionButtonGroup
        //                     editObject={step}
        //                     label="Stategy"
        //                     propertyName={BaseFlowRuleStep.OUTCOME_STRATEGY}
        //                     updateCallback={() => {
        //                         // if (step.sequence && step.sequence?.editContext) {
        //                         //     step.sequence?.editContext?.onStepEdit(step.sequence, step);
        //                         // }
        //                         StateManager.propertyChanged(step, BaseFlowRuleStep.OUTCOME_STRATEGY);
        //                     }}
        //                 />
        //             )}
        //         />
        //     )}
        //
        //     <UILayer
        //         open={open}
        //         maxWidth={false}
        //         fullScreen
        //         padding="0px 0px"
        //         renderUI={() => (
        //             <IntersectionRuleBuilder
        //                 ruleDefinition={step.executable}
        //                 title={step.executable.title || step.name}
        //                 onRuleCancel={() => {
        //                     setOpen(false);
        //                 }}
        //                 onRuleSave={() => {
        //                     StateManager.changed(step);
        //                     setOpen(false);
        //                 }}
        //             />
        //         )}
        //         onClose={() => setOpen(false)}
        //     />
        // </>
    );
};

export class RunIntersectionRuleEditor extends FlowStepEditor<RunIntersectionRule> {
    renderEditUI(): JSX.Element | null {
        return <StepEditUI step={this.stepData} />;
    }
}
